export enum TextFilterOperators {
  Empty = "empty",
  NotEmpty = "not-empty",
  Contains = "contains",
  NotContains = "not-contains"
}
